import React, { useCallback, useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Eye } from "iconsax-react";
import CustomPagination from "../../Utils/CustomPagination";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import View from "./CounterWiseGraphView";
import Select from "react-select";
import KeyPersonWiseView from "./KeyPersonWiseGraphView";

function List(props) {
  const [counterList, setCounterList] = useState([]);
  const [filters, setFilters] = useState({
    counterName: [],
    contact: "",
    city: "",
    state: "",
    empCode: "",
    district: "",
  });
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [appliedFilters, setAppliedFilters] = useState({ ...filters });
  const [counter, setCounter] = useState([]);
  const [showGraph, setShowGraph] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [activeTab, setActiveTab] = useState("counterWise");

  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  useEffect(() => {
    getCounter();
  }, []);

  const getCounter = () => {
    utils
      .callAPI("get", `/sales/dealer-distributor-list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setCounter(res);
        } else {
          setCounter([]);
        }
      })
      .catch((err) => {
        setCounter([]);
      });
  };

  const counterWiseColumns = [
    {
      name: "Counter",
      selector: (row) => row.dealership_name,
      width: "220px",
    },
    // {
    //   name: "Key Person",
    //   selector: (row) => row.emp_name,
    // },
    // { name: "Employee Code", selector: (row) => row.employeeId },
    { name: "State", selector: (row) => row.company_state },
    { name: "District", selector: (row) => row.company_district },
    { name: "City", selector: (row) => row.company_city },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <RB.Button
          className="btn-flat me-1"
          title="View"
          onClick={handleView(row)}
        >
          <Eye />
        </RB.Button>
      ),
    },
  ];

  const keyPersonWiseColumns = [
    {
      name: "Key Person",
      selector: (row) => row.emp_name,
    },
    { name: "Employee Code", selector: (row) => row.employeeId },
    // { name: "State", selector: (row) => row.company_state },
    // { name: "District", selector: (row) => row.company_district },
    // { name: "City", selector: (row) => row.company_city },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <RB.Button
          className="btn-flat me-1"
          title="View"
          onClick={handleView(row)}
        >
          <Eye />
        </RB.Button>
      ),
    },
  ];

  const columns =
    activeTab === "counterWise" ? counterWiseColumns : keyPersonWiseColumns;

  const handleView = useCallback(
    (row) => async () => {
      setShowGraph(true);
      setCurrentRow(row);
    },
    []
  );

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleFind = () => {
    setAppliedFilters(filters);
    setPage(1);
    setShowGraph(false);
  };

  const handleReset = () => {
    const resetFilters = {
      counterName: [],
      contact: "",
      city: "",
      state: "",
      empCode: "",
      district: "",
    };
    setFilters(resetFilters);
    setAppliedFilters(resetFilters);
    setPage(1);
    setShowGraph(false);
  };

  const getCounterList = useCallback(() => {
    const { counterName, contact, empCode, city, state, district } =
      appliedFilters;

    const counterIds = Array.isArray(counterName)
      ? counterName.join(",")
      : counterName;

    let apiUrl = "";
    if (activeTab === "counterWise") {
      apiUrl = `meeting/counter/list?page=${page}&per_page=${countPerPage}&counter_name=${counterIds}&key_person=${contact}&city=${city}&state=${state}&district=${district}&emp_code=${empCode}`;
    } else if (activeTab === "keyPersonWise") {
      apiUrl = `meeting/counter/list-key-persion-wise?counter_name=${counterIds}&key_person=${contact}&city=${city}&state=${state}&district=${district}&emp_code=${empCode}&page=${page}&per_page=${countPerPage}`;
    }

    utils
      .callAPI("get", apiUrl)
      .then((res) => setCounterList(res || []))
      .catch(() => setCounterList([]));
  }, [page, appliedFilters, activeTab]);

  useEffect(() => {
    getCounterList();
  }, [page, getCounterList]);

  return (
    <>
      <RB.Tabs
        activeKey={activeTab}
        onSelect={(k) => {
          setActiveTab(k);
          setShowGraph(false);
        }}
        className="mb-3"
      >
        <RB.Tab eventKey="counterWise" title="Counter Wise">
          <RB.Row className="mb-3">
            <RB.Col md={3}>
              <Select
                isMulti
                name="counterName"
                placeholder="Select Counter"
                value={counter
                  .filter((c) => filters.counterName.includes(c.id))
                  .map((c) => ({
                    value: c.id,
                    label: `${c.companyName} (${c.vendor_type})`,
                  }))}
                onChange={(selected) => {
                  const ids = selected.map((option) => option.value);
                  setFilters({ ...filters, counterName: ids });
                }}
                options={counter.map((m) => ({
                  value: m.id,
                  label: `${m.companyName} (${m.vendor_type})`,
                }))}
              />
            </RB.Col>
            {/* <RB.Col md={3}>
              <RB.Form.Control
                type="text"
                placeholder="Key Person"
                name="contact"
                value={filters.contact}
                onChange={handleFilterChange}
              />
            </RB.Col>
            <RB.Col md={3}>
              <RB.Form.Control
                type="text"
                placeholder="Employee Code"
                name="empCode"
                value={filters.empCode}
                onChange={handleFilterChange}
              />
            </RB.Col> */}
            <RB.Col md={2}>
              <RB.Form.Control
                type="text"
                placeholder="State"
                name="state"
                value={filters.state}
                onChange={handleFilterChange}
              />
            </RB.Col>
            <RB.Col md={2}>
              <RB.Form.Control
                type="text"
                placeholder="District"
                name="district"
                value={filters.district}
                onChange={handleFilterChange}
              />
            </RB.Col>
            <RB.Col md={2}>
              <RB.Form.Control
                type="text"
                placeholder="City"
                name="city"
                value={filters.city}
                onChange={handleFilterChange}
              />
            </RB.Col>
            <RB.Col md={3}>
              <RB.Button variant="primary" onClick={handleFind}>
                Find
              </RB.Button>
              <RB.Button
                variant="secondary"
                onClick={handleReset}
                className="ms-2"
              >
                Reset
              </RB.Button>
            </RB.Col>
          </RB.Row>

          <DataTable
            columns={columns}
            data={counterList?.list?.result}
            highlightOnHover
            responsive
            pagination
            paginationServer
            paginationTotalRows={counterList?.list?.total}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            paginationComponent={() => (
              <CustomPagination
                currentPage={page}
                totalRows={counterList?.list?.total}
                rowsPerPage={countPerPage}
                onPageChange={handlePageChange}
              />
            )}
            striped
            onChangePage={(page) => setPage(page)}
            persistTableHead
            customStyles={{
              head: {
                style: {
                  fontSize: "0.875rem",
                  fontWeight: "bold",
                },
              },
            }}
          />

          {/* <h5 className="fw-bold ms-3 mt-3">
            Total Expense (₹
            {parseFloat(counterList.total_amt || 0).toLocaleString()}) ÷ Total
            Sale (₹
            {parseFloat(counterList.sales_amt || 0).toLocaleString()}) =
            {parseFloat(counterList.total_percent || 0)}%
          </h5> */}
        </RB.Tab>

        <RB.Tab eventKey="keyPersonWise" title="Key Person Wise">
          <RB.Row className="mb-3">
            {/* <RB.Col md={3}>
                  <Select
                    isMulti
                    name="counterName"
                    placeholder="Select Counter"
                    value={counter
                      .filter((c) => filters.counterName.includes(c.id))
                      .map((c) => ({
                        value: c.id,
                        label: `${c.companyName} (${c.vendor_type})`,
                      }))}
                    onChange={(selected) => {
                      const ids = selected.map((option) => option.value);
                      setFilters({ ...filters, counterName: ids });
                    }}
                    options={counter.map((m) => ({
                      value: m.id,
                      label: `${m.companyName} (${m.vendor_type})`,
                    }))}
                  />
                </RB.Col> */}
            <RB.Col md={3}>
              <RB.Form.Control
                type="text"
                placeholder="Key Person"
                name="contact"
                value={filters.contact}
                onChange={handleFilterChange}
              />
            </RB.Col>
            <RB.Col md={3}>
              <RB.Form.Control
                type="text"
                placeholder="Employee Code"
                name="empCode"
                value={filters.empCode}
                onChange={handleFilterChange}
              />
            </RB.Col>
            {/* <RB.Col md={2}>
              <RB.Form.Control
                type="text"
                placeholder="State"
                name="state"
                value={filters.state}
                onChange={handleFilterChange}
              />
            </RB.Col>
            <RB.Col md={2}>
              <RB.Form.Control
                type="text"
                placeholder="District"
                name="district"
                value={filters.district}
                onChange={handleFilterChange}
              />
            </RB.Col>
            <RB.Col md={2}>
              <RB.Form.Control
                type="text"
                placeholder="City"
                name="city"
                value={filters.city}
                onChange={handleFilterChange}
              />
            </RB.Col> */}
            <RB.Col md={2}>
              <RB.Button variant="primary" onClick={handleFind}>
                Find
              </RB.Button>
              <RB.Button
                variant="secondary"
                onClick={handleReset}
                className="ms-2"
              >
                Reset
              </RB.Button>
            </RB.Col>
          </RB.Row>

          <DataTable
            columns={columns}
            data={counterList?.list?.result}
            highlightOnHover
            responsive
            pagination
            paginationServer
            paginationTotalRows={counterList?.list?.total}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            paginationComponent={() => (
              <CustomPagination
                currentPage={page}
                totalRows={counterList?.list?.total}
                rowsPerPage={countPerPage}
                onPageChange={handlePageChange}
              />
            )}
            striped
            onChangePage={(page) => setPage(page)}
            persistTableHead
            customStyles={{
              head: {
                style: {
                  fontSize: "0.875rem",
                  fontWeight: "bold",
                },
              },
            }}
          />

          <h5 className="fw-bold">
            Total Marketing Expense = ₹
            {parseFloat(counterList.total_amt || 0).toLocaleString()}/-
          </h5>

          <h5 className="fw-bold">
            Total Sales = ₹
            {parseFloat(counterList.sales_amt || 0).toLocaleString()}/-
          </h5>

          {(() => {
            const percent = parseFloat(counterList.total_percent || 0) || 0;
            const formatted = percent.toFixed(2); // ✅ 2 decimal places
            const color = percent >= 3 ? "red" : "green"; // ✅ red/green condition

            return (
              <h5 className="fw-bold" style={{ color }}>
                Budget Percentage = {formatted}%
              </h5>
            );
          })()}
        </RB.Tab>
      </RB.Tabs>

      {showGraph && activeTab === "counterWise" && (
        <View setShowGraph={setShowGraph} rowData={currentRow} />
      )}

      {showGraph && activeTab === "keyPersonWise" && (
        <KeyPersonWiseView setShowGraph={setShowGraph} rowData={currentRow} />
      )}
    </>
  );
}

export default List;
